/*******************************************************************************
 * Copyright (c) 2026 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {
  PaginationInfo,
  PaginationInfoApiResponse,
  paginationInfoFromApiResponse,
} from '@shared/models/pagination-info';

export enum IamTokenGrantFlow {
  clientCredentials = 'GRANT_FLOW_CLIENT_CREDENTIALS',
  password = 'GRANT_FLOW_PASSWORD',
  entitySetup = 'GRANT_FLOW_ENTITY_SETUP',
  login = 'GRANT_FLOW_LOGIN',
}

export interface IamToken {
  tokenId: string;
  accountId: string | null;
  userId: string | null;
  tokenType: string;
  expiresIn: number;
  scopes: string[];
  roles: string[];
  grantFlow: IamTokenGrantFlow | null;
  createdAt: string;
  accessTokenRevokedAt: string | null;
}

export interface IamTokenApiResponse {
  token_id: string;
  account_id?: string;
  user_id?: string;
  token_type: string;
  expires_in: number;
  scopes: string[];
  roles: string[];
  grant_flow?: string;
  created_at: string;
  access_token_revoked_at?: string;
}

export interface IamTokensApiResponse {
  tokens: IamTokenApiResponse[];
  pagination_info: PaginationInfoApiResponse;
}

export interface IamTokensPagination {
  tokens: IamToken[];
  pagination: PaginationInfo;
}

export const iamTokenFromApiResponse = (response: IamTokenApiResponse): IamToken => {
  return {
    tokenId: response.token_id,
    accountId: response.account_id ?? null,
    userId: response.user_id ?? null,
    tokenType: response.token_type,
    expiresIn: response.expires_in,
    scopes: response.scopes ?? [],
    roles: response.roles ?? [],
    grantFlow: (response.grant_flow as IamTokenGrantFlow) ?? null,
    createdAt: response.created_at,
    accessTokenRevokedAt: response.access_token_revoked_at ?? null,
  };
};

export const iamTokensPaginationFromApiResponse = (
  response: IamTokensApiResponse
): IamTokensPagination => {
  return {
    tokens: response.tokens.map(iamTokenFromApiResponse),
    pagination: paginationInfoFromApiResponse(response.pagination_info),
  };
};
